module.exports = __webpack_public_path__ + "img/sleeping.120c305d.png";